package com.htmlagent.site.state

import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.localStorage
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import org.w3c.dom.get
import org.w3c.dom.set

/** What the person asked for: follow the system, or one mode whatever the system says. */
enum class ThemeChoice {
    AUTO, LIGHT, DARK;

    /** The mode this choice paints with while the system is in [system]. */
    fun resolve(system: ColorMode): ColorMode = when (this) {
        AUTO -> system
        LIGHT -> ColorMode.LIGHT
        DARK -> ColorMode.DARK
    }
}

/**
 * The color mode preference, kept apart from the mode being painted.
 *
 * Silk stores the painted mode, and storing it on first render froze whatever the system said
 * that day: the app never followed the system again. Only an explicit choice is written here;
 * with nothing stored the choice is [ThemeChoice.AUTO]. `splash/splash.js` reads the same key.
 */
object ThemePreference {

    private const val KEY = "html-agent.theme"

    private val state = MutableStateFlow(load())

    val current: StateFlow<ThemeChoice> = state.asStateFlow()

    fun set(choice: ThemeChoice) {
        state.value = choice
        runCatching {
            if (choice == ThemeChoice.AUTO) localStorage.removeItem(KEY) else localStorage[KEY] = choice.name
        }
    }

    private fun load(): ThemeChoice =
        runCatching { localStorage[KEY] }.getOrNull()
            ?.let { saved -> ThemeChoice.entries.firstOrNull { it.name == saved } }
            ?: ThemeChoice.AUTO
}
